import {FocusEventHandler, FormEventHandler} from 'react';
import {Form} from 'react-bootstrap';
import clsx from 'clsx';

interface TextAreaInputControlledProps {
    name: string;
    value: string;
    label: string;
    rows?: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: FocusEventHandler;
    onReset: FormEventHandler | undefined;
    isDisabled?: boolean;
    touched: boolean | undefined;
    errors: string | undefined;
    maxLength?: number;
    required?: boolean;
}
const TextAreaInputControlled = ({
    name,
    value,
    label,
    rows,
    onChange,
    onBlur,
    onReset,
    isDisabled,
    touched,
    errors,
    maxLength,
    required = true,
}: TextAreaInputControlledProps): JSX.Element => {
    return (
        <Form.Group>
            <Form.Label className={clsx('fw-bold fs-3', {required})}>{label}</Form.Label>
            <Form.Control
                name={name}
                value={value}
                className={clsx(
                    {'is-invalid': touched && errors},
                    {'is-valid': touched && !errors}
                )}
                as="textarea"
                rows={rows ?? 6}
                onChange={onChange}
                onBlur={onBlur}
                onReset={onReset}
                disabled={isDisabled}
                maxLength={maxLength}
            />
            {touched && errors && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">{errors}</span>
                    </div>
                </div>
            )}
        </Form.Group>
    );
};

export default TextAreaInputControlled;
